import { Col, Properties, Property, Row } from '../../../Common/Property';
import { CodeGroup } from '../../../Common/Code';
import Eyebrow from '../../../Common/Eyebrow';
import { Note } from '../../../Common/Note';

const ROUTE = '/flight/sandbox/domestic/round/rules';

export default function Docs() {
  return (
    <>
      <Eyebrow label={ROUTE} tag='POST' />
      <h1>Fare Rules</h1>
      <p>
        As the name suggests, employees are a core part of Dice — the very
        reason Dice exists is so you can provide secure spends management to
        your employees. On this page, we'll dive into how to create employees
        programmatically.
      </p>
      <h2>Request Model</h2>
      <p className='lead'>
        Details of all the parameters that can be passed in the request.
      </p>
      <Row>
        <Col>
          <Properties>
            <Property name='fareId' type='string'>
              Value can be extracted from Fare Rules api response.
            </Property>
            <Property name='inventoryId' type='string'>
              Value can be extracted from Fare Rules api response.
            </Property>
            <Note>
              <code>fareId</code> & <code>inventoryId</code> are valid for only
              15 mins
            </Note>
          </Properties>
        </Col>
        <Col>
          <CodeGroup tag='POST' label={ROUTE} title='Request Payload'>
            <code title='cURL'>
              curl --request POST \ <br />
              --url {ROUTE} \ <br />
              --header 'Origin: Dice' \ <br />
              --header 'accept: application/json' \ <br />
              --header 'content-type: application/json' <br />
            </code>
          </CodeGroup>

          <CodeGroup title='Response Pay Load'>
            <code title='json'>
              {JSON.stringify(
                {
                  success: true,
                  app: 'Trip Jack Flights',
                  fareRules: {
                    cancellation: {
                      policy:
                        'Cancellation is not permitted | For more details contact us',
                      aggregatorFees: 0,
                      aggregatorTax: 0,
                    },
                    dateChange: {
                      policy:
                        'Changes are not permitted | Booking confirmation will take minimum 60 Minutes',
                      aggregatorFees: 0,
                      aggregatorTax: 0,
                    },
                    noShow: {
                      policy:
                        'No Refund| Seats are Subject to availability | In case of non availability of the seats, we will refund the amount | "Sunday is Non Working day for Special Fare Team"| Booking done after 18:00 Hrs or 6 PM, PNR will be updated next working day after 11:00 Hrs or 11 AM',
                      airlineFees: 0,
                      aggregatorFees: 0,
                      airlineTax: 0,
                      aggregatorTax: 0,
                    },
                    errors: [],
                    code: 200,
                  },
                },
                null,
                2
              )}
            </code>
          </CodeGroup>
        </Col>
      </Row>
    </>
  );
}
